import { atom } from 'recoil';

interface IAutomaticDebitData {
  paymentLink: string;
}

export const automaticDebitData = atom<IAutomaticDebitData | null>({
  key: 'automaticDebitData',
  default: null,
});
